// extracted by css-extract-rspack-plugin
export default {"DateInput":"DatePicker_DateInput__0+DBr","DatePicker":"DatePicker_DatePicker__GwKuP"};